import QueryString from 'qs'

export default {
  path: '/',
  component: () => import('@/views/dashboard/Index'),
  children: [
    // Dashboard
    {
      name: 'dashboard',
      path: '',
      component: () => import('@/views/dashboard/Dashboard'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },

    // Customers
    {
      name: 'customers',
      path: '/customers',
      component: () => import('@/views/dashboard/customers/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'customer_details_views',
      path: 'customers/:id/:view',
      component: () => import('@/views/dashboard/customers/Edit'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },

    {
      name: 'customer_details',
      path: 'customers/:id',
      component: () => import('@/views/dashboard/customers/Edit'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },

    // Labels
    {
      name: 'labels',
      path: '/labels',
      beforeEnter: to => {
        const result = QueryString.stringify(to.query, { arrayFormat: 'brackets' })

        return result ? window.open(`https://partner.homerunner.com/shipments?${result}`, '_blank') : window.open('https://partner.homerunner.com/shipments', '_blank')
      },
    },
    {
      name: 'label_details',
      path: 'labels/:id',
      beforeEnter: (to) => {
        return window.open(`https://partner.homerunner.com/shipments/${to.params.id}`, '_blank')
      },
        },
    // Currencies
    {
      name: 'currencies',
      path: 'currencies',
      component: () => import('@/views/dashboard/currencies/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    // Dimensions
    {
      name: 'dimensions',
      path: 'dimensions',
      component: () => import('@/views/dashboard/dimensions/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    // Fuels
    {
      name: 'fuels',
      path: 'fuels',
      component: () => import('@/views/dashboard/fuels/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    // Fees
    {
      name: 'fees',
      path: 'carrier-fees',
      component: () => import('@/views/dashboard/fees/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    // Carriers
    {
      name: 'carriers',
      path: 'carriers',
      component: () => import('@/views/dashboard/carriers/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    // Agreements
    {
      name: 'carrier_agreements',
      path: 'carrier-agreements',
      component: () => import('@/views/dashboard/carrier_agreements/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'carrier_agreement',
      path: 'carrier-agreements/details/:id',
      component: () => import('@/views/dashboard/carrier_agreements/Edit'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'claims',
      path: 'claims',
      component: () => import('@/views/dashboard/claims/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'consolidated_invoices',
      path: 'consolidated_invoices',
      component: () => import('@/views/dashboard/consolidated_invoices/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'specifications',
      path: 'specifications',
      component: () => import('@/views/dashboard/specifications/Main'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'specifications_view',
      path: 'specifications/:view',
      component: () => import('@/views/dashboard/specifications/Main'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    // Transit
    {
      name: 'transit_prices',
      path: 'transit/prices',
      component: () => import('@/views/dashboard/transit/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'linehaul',
      path: 'transit/linehaul',
      component: () => import('@/views/dashboard/linehaul/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'linehaul_test',
      path: 'transit/linehaul/test',
      component: () => import('@/views/dashboard/linehaul/Test'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'linehaul_routes',
      path: 'transit/linehaul/routes',
      component: () => import('@/views/dashboard/linehaul_routes/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },

    {
      name: 'linehaul_routes_map',
      path: 'transit/linehaul/routes/map',
      component: () => import('@/views/dashboard/linehaul_routes/Map'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'linehaul_route',
      path: 'transit/linehaul/routes/:id',
      component: () => import('@/views/dashboard/linehaul_routes/Edit'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'packaging_products',
      path: 'packaging-products',
      component: () => import('@/views/dashboard/packaging_products/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'barcodes',
      path: 'barcodes',
      component: () => import('@/views/dashboard/barcodes/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'price_groups',
      path: 'price-groups',
      component: () => import('@/views/dashboard/price_groups/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'price_group_details',
      path: 'price-groups/:id',
      component: () => import('@/views/dashboard/price_groups/Edit'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'product_groups',
      path: 'product-groups',
      component: () => import('@/views/dashboard/product_groups/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'quickpay_card_payments',
      path: 'payments/quickpay/creditcard',
      component: () =>
        import('@/views/dashboard/payments/quickpay/creditcard/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'quickpay_card_payment',
      path: 'payments/quickpay/creditcard/:id',
      component: () =>
        import('@/views/dashboard/payments/quickpay/creditcard/Edit'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'quickpay_subscriptions',
      path: 'payments/quickpay/subscription',
      component: () =>
        import('@/views/dashboard/payments/quickpay/subscription/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'quickpay_subscription',
      path: 'payments/quickpay/subscription/:id',
      component: () =>
        import('@/views/dashboard/payments/quickpay/subscription/Edit'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },

    {
      name: 'valitor_card_payments',
      path: 'payments/valitor/creditcard',
      component: () =>
        import('@/views/dashboard/payments/valitor/creditcard/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'valitor_card_payment',
      path: 'payments/valitor/creditcard/:id',
      component: () =>
        import('@/views/dashboard/payments/valitor/creditcard/Edit'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'users',
      path: 'users',
      component: () => import('@/views/dashboard/users/List'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,

        superuser: true,
      },
    },
    {
      name: 'user_details',
      path: 'users/:id',
      component: () => import('@/views/dashboard/users/Edit'),
      meta: {
        requiresAuth: true,
        coolrunnerOnly: true,

        superuser: true,
      },
    },
    {
      name: 'tools_file',
      path: 'tools/file',
      component: () => import('@/views/dashboard/tools/file/Index'),
      meta: {
        requiresAuth: true,
        superuser: false,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'tools_style_guide',
      path: 'tools/style-guide',
      component: () => import('@/views/dashboard/tools/style_guide/Index'),
      meta: {
        requiresAuth: true,
        superuser: false,
        coolrunnerOnly: true,
      },
    },

    {
      name: 'tools_consolidated_invoices',
      path: 'tools/consolidated-invoices',
      component: () =>
        import('@/views/dashboard/tools/consolidated_invoice/Index'),
      meta: {
        requiresAuth: true,
        superuser: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'tools_pallet_missing',
      path: 'tools/pallet-missing',
      component: () => import('@/views/dashboard/tools/pallet_missing/Index'),
      meta: {
        requiresAuth: true,
        superuser: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'client_logs',
      path: 'logs/client',
      component: () => import('@/views/dashboard/logs/client/List'),
      meta: {
        requiresAuth: true,
        superuser: true,
        coolrunnerOnly: true,
      },
    },

    {
      name: 'client_log',
      path: 'logs/client/:id',
      component: () => import('@/views/dashboard/logs/client/Edit'),
      meta: {
        requiresAuth: true,
        superuser: true,
        coolrunnerOnly: true,
      },
    },

    {
      name: 'input_logs',
      path: 'logs/input',
      component: () => import('@/views/dashboard/logs/input/List'),
      meta: {
        requiresAuth: true,
        superuser: true,
        coolrunnerOnly: true,
      },
    },

    {
      name: 'input_log',
      path: 'logs/input/:id',
      component: () => import('@/views/dashboard/logs/input/Edit'),
      meta: {
        requiresAuth: true,
        superuser: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'address_logs',
      path: 'logs/address',
      component: () => import('@/views/dashboard/logs/address/List'),
      meta: {
        requiresAuth: true,
        superuser: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'tracking',
      path: 'tools/tracking',
      component: () => import('@/views/dashboard/tracking/List'),
      meta: {
        requiresAuth: true,
        superuser: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'translations',
      path: 'tools/translations',
      component: () => import('@/views/dashboard/translations/List'),
      meta: {
        requiresAuth: true,
        superuser: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'mail',
      path: 'misc/mail',
      component: () => import('@/views/dashboard/misc/mails/mail/List'),
      meta: {
        requiresAuth: true,
        superuser: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'mail_group',
      path: 'misc/group',
      component: () => import('@/views/dashboard/misc/mails/group/List'),
      meta: {
        requiresAuth: true,
        superuser: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'sql_jobs',
      path: 'misc/sql-jobs',
      component: () => import('@/views/dashboard/misc/mails/sql_jobs/List'),
      meta: {
        requiresAuth: true,
        superuser: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'app_versions',
      path: 'tools/app/versions',
      component: () => import('@/views/dashboard/app_versions/List'),
      meta: {
        requiresAuth: true,
        superuser: true,
        coolrunnerOnly: true,
      },
    },
    {
      name: 'app_devices',
      path: 'tools/app/devices',
      component: () => import('@/views/dashboard/app_devices/List'),
      meta: {
        requiresAuth: true,
        superuser: true,
        coolrunnerOnly: true,
      },
    },
  ],
}
